import { useMutation } from '@tanstack/react-query';

import { mutationFn } from '@/lib/react-query';

const cancelDischargeFn = (dischargeId: number) => {
  return mutationFn(`/self-service/objects/additional-discharges/${dischargeId}`, null, 'delete');
};

export const useCancelDischarge = () =>
  useMutation({
    mutationFn: (dischargeId: number) => cancelDischargeFn(dischargeId),
  });
